<button
  mat-icon-button
  (click)="openSearch()"
  class="text-pmdf-base-primary hover:bg-nav-hover-bg transition-colors duration-200"
  aria-label="Buscar"
>
  <mat-icon>search</mat-icon>
</button>
